import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var ArchiveModeService = /** @class */ (function () {
    function ArchiveModeService() {
        this.archiveModeBS = new BehaviorSubject({
            isArchive: false,
            disableToggle: false
        });
    }
    // Set archive mode by current tab & layer
    ArchiveModeService.prototype.resetArchiveMode = function (currentTabKey, selectedLayer) {
        // const selectedTab = this.activityService.selectedTabBS.getValue();
        // const tabKey = selectedTab ? selectedTab.tabKey : null;
        // const selectedLayer = this.activityService.selectedLayerBS.getValue();
        var layerState = selectedLayer.state;
        if (currentTabKey === 'batch') {
            if (layerState.num < 2) {
                this.archiveModeBS.next({
                    isArchive: false,
                    disableToggle: true
                });
            }
            else {
                this.archiveModeBS.next({
                    isArchive: this.archiveModeBS.getValue().isArchive,
                    disableToggle: false
                });
            }
        }
        else if (currentTabKey === 'data' || currentTabKey === 'data-addr' || currentTabKey === 'data-centerline') {
            this.archiveModeBS.next({
                isArchive: true,
                disableToggle: true
            });
        }
    };
    ArchiveModeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ArchiveModeService_Factory() { return new ArchiveModeService(); }, token: ArchiveModeService, providedIn: "root" });
    return ArchiveModeService;
}());
export { ArchiveModeService };
